import React, { Component, PropTypes } from "react";
import { connect } from "react-redux";
import {
  getCustomerRecentNotes,
  updateIsCustomerNoteEditorOpen,
  updateNewCustomerNote,
  saveNewCustomerNote,
  deleteCustomerNote,
  updateEditingNote,
  saveEditCustomerNote,
  updateExpandedNoteId,
  setIsLoadingOnCustomerNotes,
  clearCustomerNoteApiError
} from "../../../actions/customerNotes";
import { TextArea, Table, Dimmer, Loader } from "semantic-ui-react";
import CustomerNoteTableCell from "./customerNoteTableCell/customerNoteTableCell";
import moment from "moment";
import { momentTimezone } from "../../../utils/momentTimezone";
import { updateGlobalErrorMessage } from "../../../actions/globalError";

const timezoneMoment = momentTimezone(moment);
@connect(mapStateToProps)
export default class CenterPanelCustomerNotes extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    if (this.props.appointmentStepData.selectedCustomer.id) {
      this.props.dispatch(
        getCustomerRecentNotes(
          this.props.appointmentStepData.selectedCustomer.id
        )
      );
      this.showLoadingSpinner();
    }
    if (this.props.isCustomerNoteEditorOpen || this.props.editingNoteId) {
      this.resetEditingState();
    }
  }

  componentDidUpdate = () => {
    if (this.props.apiErrorReasons) {
      const reasonObj = this.props.apiErrorReasons[0];
      let errorMsg = reasonObj.description;
      if (!errorMsg || errorMsg.length === 0) {
        errorMsg = window.APP.LANGUAGE.Errors.DefaultApiErrorMessage;
      }
      this.props.dispatch(updateGlobalErrorMessage({ message: errorMsg }));
      this.props.dispatch(clearCustomerNoteApiError());
    }
  };

  resetEditingState = () => {
    this.props.dispatch(updateIsCustomerNoteEditorOpen(false));
    this.props.dispatch(updateEditingNote(null, ""));
  };

  newNoteChangedHandler = event => {
    this.props.dispatch(updateNewCustomerNote(event.target.value));
  };

  newNoteOnClickHandler = () => {
    this.props.dispatch(updateIsCustomerNoteEditorOpen(true));
  };

  newNoteCloseClickHandler = () => {
    this.resetEditingState();
  };

  noteSaveClickHandler = () => {
    if (
      this.props.appointmentStepData.selectedCustomer.id &&
      this.props.newCustomerNote.length > 0
    ) {
      if (this.props.editingNoteId) {
        this.props.dispatch(
          saveEditCustomerNote(
            this.props.appointmentStepData.selectedCustomer.id,
            this.props.newCustomerNote,
            this.props.editingNoteId
          )
        );
      } else {
        this.props.dispatch(
          saveNewCustomerNote(
            this.props.appointmentStepData.selectedCustomer.id,
            this.props.newCustomerNote
          )
        );
      }
      this.showLoadingSpinner();
    }
  };

  deleteNoteHandler = noteId => {
    this.props.dispatch(
      deleteCustomerNote(
        this.props.appointmentStepData.selectedCustomer.id,
        noteId
      )
    );
    this.showLoadingSpinner();
  };

  editNoteHandler = (noteId, noteContent) => {
    this.props.dispatch(updateEditingNote(noteId, noteContent));
    this.props.dispatch(updateIsCustomerNoteEditorOpen(true));
  };

  expandContractNotehandler = noteId => {
    if (noteId === this.props.expandedNoteId) {
      noteId = null;
    }
    this.props.dispatch(updateExpandedNoteId(noteId));
  };

  showLoadingSpinner = () => {
    this.props.dispatch(setIsLoadingOnCustomerNotes(true));
  };

  getAddNewNoteSection = () => {
    let { limitedPermissions } = this.props;
    let {
      Pages: { CustomerNotes }
    } = window.APP.LANGUAGE;

    if (!limitedPermissions.canEditCustomerProfile) {
      return "";
    }

    return (
      <section className="customer_new_note">
        <h5 className="label-title" onClick={this.newNoteOnClickHandler}>
          {CustomerNotes.AddNewNoteTitle}
        </h5>
        <div className="row">
          <div className="col-xs-12" onClick={this.newNoteOnClickHandler}>
            <input
              type="text"
              className="new_note"
              placeholder={CustomerNotes.AddNewNotesPlaceholder}
            />
          </div>
        </div>
      </section>
    );
  };

  render() {
    const todayDate = moment();
    let {
      loadingCustomerNotes,
      isCustomerNoteEditorOpen,
      limitedPermissions
    } = this.props;
    let noteCenterPanelContent = null;
    if (isCustomerNoteEditorOpen) {
      let saveButtonClass = "save_note_disabled";
      let saveButtonClickHandler = null;
      if (this.props.newCustomerNote.length > 0) {
        saveButtonClass = "save_note";
        saveButtonClickHandler = this.noteSaveClickHandler;
      }
      noteCenterPanelContent = (
        <div className="new_note_popup">
          <p className="new_note_date">
            {todayDate
              .tz(this.props.appointmentStepData.timezone)
              .format("MMMM DD, YYYY")}
          </p>
          <TextArea
            autoFocus
            className="new_note_textarea"
            name="newnotetext"
            placeholder={
              window.APP.LANGUAGE.Pages.CustomerNotes.NewNotePlaceholder
            }
            onChange={this.newNoteChangedHandler}
            value={this.props.newCustomerNote}
          />
          <footer>
            <span
              className="close_note"
              onClick={this.newNoteCloseClickHandler}
            >
              {window.APP.LANGUAGE.Pages.CustomerNotes.NewNoteClose}
            </span>
            <span className={saveButtonClass} onClick={saveButtonClickHandler}>
              {window.APP.LANGUAGE.Pages.CustomerNotes.NewNoteSave}
            </span>
          </footer>
        </div>
      );
    } else {
      let recentNotesList = null;
      if (this.props.customerRecentNotes.length > 0) {
        recentNotesList = (
          <Table.Body>
            {this.props.customerRecentNotes.map(note => {
              const noteDate = timezoneMoment.utc(note.created);
              return (
                <CustomerNoteTableCell
                  disabled={!limitedPermissions.canEditCustomerProfile}
                  key={note.id}
                  noteCreatedDate={noteDate
                    .tz(this.props.appointmentStepData.timezone)
                    .format("MMMM DD, YYYY")}
                  noteContent={note.note}
                  deleteNoteClicked={() => this.deleteNoteHandler(note.id)}
                  editNoteClicked={() =>
                    this.editNoteHandler(note.id, note.note)
                  }
                  expandNoteClicked={() =>
                    this.expandContractNotehandler(note.id)
                  }
                  isExpanded={note.id === this.props.expandedNoteId}
                />
              );
            })}
          </Table.Body>
        );
      }
      noteCenterPanelContent = (
        <div>
          {this.getAddNewNoteSection()}
          <section className="customer_recent_note">
            <Table basic="very">
              <Table.Header>
                <Table.Row>
                  <Table.HeaderCell className="label-title">
                    {window.APP.LANGUAGE.Pages.CustomerNotes.RecentNotesTitle}
                  </Table.HeaderCell>
                </Table.Row>
              </Table.Header>
              <Table.Header className="customer_recent_note_list">
                {recentNotesList}
              </Table.Header>
            </Table>
          </section>
        </div>
      );
    }
    return (
      <div className="tabpane customernotes_tab">
        <Dimmer active={loadingCustomerNotes}>
          <Loader />
        </Dimmer>
        {noteCenterPanelContent}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    appointmentStepData: state.appointmentStepReducer.appointmentStepData,
    customerRecentNotes: state.customerNotesReducer.customerRecentNotes,
    isCustomerNoteEditorOpen:
      state.customerNotesReducer.isCustomerNoteEditorOpen,
    newCustomerNote: state.customerNotesReducer.newCustomerNote,
    editingNoteId: state.customerNotesReducer.editingNoteId,
    expandedNoteId: state.customerNotesReducer.expandedNoteId,
    limitedPermissions: state.appointmentStepReducer.limitedPermissions,
    loadingCustomerNotes: state.customerNotesReducer.loadingCustomerNotes
  };
}
